export default {"src":"/_next/static/media/my-deposits.faa850cf.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};